<template lang="pug">
  footer
    .container.mx-auto
      //transition(name="fade")
        div#to-top(@click="toTop" v-if="scY > 50")
          font-awesome-icon(icon="angle-up")

      .footer-wrap.container.mx-auto
        .logo
          img(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
          img(v-else src="@/assets/weinankauf.svg")   
        .adress MaisonVin vins par excellence GmbH <br>Wiesenstraße 4 <br>D-47906 Kempen
        .tel Tel: <a href="tel:004921525513120">+49 (0)2152 5513120</a> <br> <a href="mailto: info@weinankauf.de">Mail: info@weinankauf.de</a>
        Menu#footer-info.menu(k="footer-menu" :max-depth="1")
        //.social
          a(href="https://www.facebook.com/weinankauf.zu.bestpreisen/" target="_blank")
            font-awesome-icon(:icon="{prefix: 'fab', iconName: 'facebook-square'}") 
    .copyright
</template>

<script>
import { mapGetters } from 'vuex';
import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';

export default {
    name: 'Footer',
    components: {
        Menu
    },
    data() {
        return {
            scTimer: 0,
            scY: 0
        };
    },
    computed: {
        image() {
            console.log(
                trim(
                    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                    '/'
                )
            );
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );
            const fit = 'fit&h=160';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },

        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            config: 'config'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll: function() {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        toTop: function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply block bottom-0 w-full text-black
    color: $maisonvin-red-dark
    //background: $weinankauf-olive
  .footer-wrap
    @apply flex relative font-normal py-16 justify-center
    > *
      @apply mr-12
    .logo
      @apply pt-1
      > img
        width: 180px
    .menu ::v-deep
      a
        @apply transition duration-200 ease-in-out
        &:hover
          @apply text-white

  div#to-top
    @apply fixed w-8 h-8 leading-8 text-center transition duration-500 ease-in-out cursor-pointer bg-black bg-opacity-75
    bottom: 17px
    right: 17px
    z-index: 200
    &:hover
      background-color: $etori-sec
      outline: 1px solid #fff

  .fade-enter,
  .fade-leave-to
    @apply opacity-0

  .fade-enter-active,
  .fade-leave-active
    @apply transition-opacity duration-500

  .copyright
    @apply h-8
    background-color: $maisonvin-red
</style>
